import { useEffect, useState } from "react";
var useTextAnimation = function (animating, _a) {
    if (animating === void 0) { animating = true; }
    var _b = _a === void 0 ? {
        texts: ["Loading", "Loading .", "Loading ..", "Loading ..."],
        interval: 250,
    } : _a, texts = _b.texts, interval = _b.interval;
    var _c = useState(texts[0]), currentText = _c[0], setCurrentText = _c[1];
    var _d = useState(0), setCounter = _d[1];
    useEffect(function () {
        if (animating) {
            var timeInterval_1 = setInterval(function () {
                setCounter(function (curr) {
                    var newCounter = curr + 1;
                    setCurrentText(texts[newCounter % texts.length]);
                    return newCounter;
                });
            }, interval);
            return function () {
                clearInterval(timeInterval_1);
            };
        }
    }, [texts, interval, animating]);
    return currentText;
};
export default useTextAnimation;
//# sourceMappingURL=useTextAnimation.js.map